import React from 'react';
import { useNavigate } from 'react-router-dom';
import ListHeroPhoto from '../ListHeroPhoto';

function CollaborationsSection({
  collaborationLists,
  isCompactView,
  isReorderMode,
  hasArchivedLists,
  onListClick,
  onCollaboratorsClick,
}) {
  const navigate = useNavigate();

  if (collaborationLists.length === 0) return null;

  return (
    <>
      <div className="section-divider">
        <h2 className="section-title">Collaborations</h2>
        <span className="section-count">{collaborationLists.length}</span>
      </div>
      <div className={`lists-grid collaborations-grid ${isCompactView ? 'compact-view' : ''} ${hasArchivedLists ? 'has-archived' : ''}`}>
        {collaborationLists.map((list) => {
          const { percentComplete, placeCount, heroItem, heroPlaceId, locationDisplay, categoryDisplay, ownerDisplay, collaboratorCount, timeSince } = list._computed;
          const placeLabel = placeCount === 1 ? 'place' : 'places';

          return (
            <div
              key={list.id}
              className={`list-preview-card collaboration ${isReorderMode ? 'disabled' : ''} ${isCompactView ? 'compact' : ''}`}
              onClick={() => !isReorderMode && onListClick(list.id)}
            >
              {!isCompactView && (
                <div className="list-preview-hero">
                  <ListHeroPhoto
                    placeId={heroPlaceId}
                    altText={list.title || list.name}
                    storedPhotoUrl={heroItem?.photoUrl}
                    photoUrlSavedAt={heroItem?.photoUrlSavedAt}
                    customPhoto={list.customPhoto}
                  />
                  <div className="list-hero-overlay" />
                  <div className="collaboration-badge">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  </div>
                  {list.hasItinerary && (
                    <button
                      className="trip-plan-badge"
                      onClick={(e) => { e.stopPropagation(); navigate(`/list/${list.id}/trip`); }}
                      aria-label="View trip plan"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                      <span>Trip</span>
                    </button>
                  )}
                </div>
              )}
              <div className="list-preview-content">
                <h3 className="list-preview-title">{list.title || list.name}</h3>
                <div className="list-preview-owner">
                  <span
                    className="creator-link collaborative-link"
                    onClick={(e) => onCollaboratorsClick(e, list.id)}
                  >
                    by {ownerDisplay}{collaboratorCount > 0 && ` & ${collaboratorCount} other${collaboratorCount === 1 ? '' : 's'}`}
                  </span>
                </div>
                <div className="list-preview-subtitle">
                  {locationDisplay && <span>{locationDisplay}</span>}
                  {locationDisplay && categoryDisplay && <span className="meta-bullet">•</span>}
                  {categoryDisplay && <span>{categoryDisplay}</span>}
                </div>
                <div className="list-preview-meta">
                  <span>{placeCount} {placeLabel}</span>
                  <span className="meta-bullet">•</span>
                  <span>{percentComplete}% visited</span>
                  {timeSince && (
                    <>
                      <span className="meta-bullet">•</span>
                      <span>{timeSince}</span>
                    </>
                  )}
                </div>
              </div>
              {isCompactView && (
                <div className="compact-badges">
                  <span className="compact-collab-badge" title="Collaboration">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  </span>
                  {list.hasItinerary && (
                    <button
                      className="compact-trip-badge"
                      onClick={(e) => { e.stopPropagation(); navigate(`/list/${list.id}/trip`); }}
                      title="View trip plan"
                      aria-label="View trip plan"
                    >
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                        <line x1="16" y1="2" x2="16" y2="6"/>
                        <line x1="8" y1="2" x2="8" y2="6"/>
                        <line x1="3" y1="10" x2="21" y2="10"/>
                      </svg>
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default CollaborationsSection;
